import { Button, Text } from "@adoptaunabuelo/react-components";
import { ArrowLeft } from "lucide-react";
import media from "styled-media-query";
import styled from "styled-components";

interface Props {
	title: string;
	step: number;
	imageSrc?: string;
	imageAlt?: string;
	onBack?: () => void;
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	background: var(--surface-background, #F9F6F3);
	padding: 8px 0 20px;
	@media (max-width: 360px) {
		padding: 8px 0 14px;
	}
`;

const HeaderRow = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 48px;
	padding: 0 24px;
	@media (max-width: 360px) {
		min-height: 44px;
		padding: 0 14px;
	}
`;

const BackButton = styled(Button)`
	position: absolute;
	margin: 0;
	padding: 12px;
	left: 0;
	@media (max-width: 360px) {
		padding: 10px;
	}
`;

const Title = styled(Text)`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align: center;
	padding: 0px 48px 0;
	width: 100%;
	@media (max-width: 360px) {
		padding: 0 38px;
		font-size: 22px;
		line-height: 1.15;
	}
`;

const ImageWrap = styled.div`
	padding: 12px 0px 0px 0px;
	@media (max-width: 360px) {
		padding-top: 8px;
	}
`;

const StepImage = styled.img`
	display: block;
	width: 100%;
	max-width: 560px;
	height: auto;
	object-fit: contain;
	margin: 0 auto;
	@media (max-width: 360px) {
		max-width: 520px;
	}
`;

const FelicitacionStepHeader = ({
	title,
	step,
	imageSrc,
	imageAlt,
	onBack,
}: Props) => {
	return (
		<Wrapper>
			<HeaderRow>
				{onBack && step > 1 && (
					<BackButton design="image" icon={<ArrowLeft />} onClick={onBack} />
				)}
				<Title type="h4" weight="semibold">
					{title}
				</Title>
			</HeaderRow>

			{imageSrc && (
				<ImageWrap>
					<StepImage alt={imageAlt ?? `Paso ${step}`} src={imageSrc} />
				</ImageWrap>
			)}
		</Wrapper>
	);
};

export default FelicitacionStepHeader;
